import TagDS from '@/components/common/ds-tag/Tag.ds';
import styles from './ProductRatingList.module.scss';

export const ProductRatingList = ({ ratings, ratingMaxNumber = 3 }) => {
  const ratingsAlter = ratings?.length > ratingMaxNumber ? ratings.slice(0, ratingMaxNumber) : ratings;

  return ratingsAlter?.length > 0 ? (
    <div className={styles.container}>
      {ratingsAlter.map((rating, index) => (
        <TagDS
          key={index}
          color="grey"
          content={
            <div className={styles.notation}>
              <div className={styles.name}> {rating.shortName} </div>
              <div className={styles.separator} />
              <div className={styles.rating}> {rating.value} </div>
            </div>
          }
          type="passive"
          size="sm"
        />
      ))}
    </div>
  ) : null;
};

export default ProductRatingList;
